/**
 * Auto-activa el filtro de disponibilidad "En existencia" al cargar la página.
 * Solo se activa si no hay filtros de disponibilidad ya aplicados en la URL.
 * Activa el checkbox en desktop y en el drawer móvil.
 */
(function () {
  "use strict";

  const APPLIED_FLAG_ATTR = "defaultAvailabilityFilterApplied";
  const OBSERVER_TIMEOUT_MS = 4000;

  function isApplied() {
    return document.documentElement.dataset[APPLIED_FLAG_ATTR] === "true";
  }

  function setApplied() {
    document.documentElement.dataset[APPLIED_FLAG_ATTR] = "true";
  }

  /**
   * @typedef {{ updateFilters?: () => void }} FacetsFormElement
   */

  /**
   * Inicializa el filtro de disponibilidad por defecto
   */
  function initDefaultAvailabilityFilter() {
    if (isApplied()) {
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const hasAvailabilityFilter = Array.from(urlParams.keys()).some(
      (key) =>
        key.includes("filter.v.availability") ||
        key.includes("filter.p.availability"),
    );

    if (hasAvailabilityFilter) {
      return;
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", setupAutoApply);
    } else {
      setupAutoApply();
    }
  }

  /**
   * Espera a que los filtros estén disponibles y aplica una sola vez.
   */
  function setupAutoApply() {
    if (isApplied()) {
      return;
    }

    if (activateInStockFilter()) {
      return;
    }

    const observer = new MutationObserver(() => {
      if (activateInStockFilter()) {
        observer.disconnect();
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    window.setTimeout(() => {
      observer.disconnect();
    }, OBSERVER_TIMEOUT_MS);
  }

  /**
   * Activa el checkbox del filtro "En existencia" en todos los formularios (desktop y drawer móvil).
   * @returns {boolean} true cuando ya existe selección o cuando se aplicó exitosamente.
   */
  function activateInStockFilter() {
    /** @type {HTMLInputElement[]} */
    const availabilityInputs = Array.from(
      document.querySelectorAll(
        'facets-form-component input[type="checkbox"][name*="filter.v.availability"], facets-form-component input[type="radio"][name*="filter.v.availability"], facets-form-component input[type="checkbox"][name*="filter.p.availability"], facets-form-component input[type="radio"][name*="filter.p.availability"]',
      ),
    );

    if (availabilityInputs.length === 0) {
      return false;
    }

    for (const input of availabilityInputs) {
      if (input.checked) {
        setApplied();
        return true;
      }
    }

    /** @type {Map<FacetsFormElement, HTMLInputElement>} */
    const inStockInputByForm = new Map();

    for (const input of availabilityInputs) {
      const facetsForm = /** @type {FacetsFormElement} */ (
        input.closest("facets-form-component")
      );
      if (!facetsForm || inStockInputByForm.has(facetsForm)) {
        continue;
      }

      if (input.value === "1" || input.value === "true") {
        inStockInputByForm.set(facetsForm, input);
        continue;
      }

      if (!input.id) {
        continue;
      }

      const label = document.querySelector(`label[for="${input.id}"]`);
      if (label) {
        const labelText = label.textContent.toLowerCase().trim();
        if (
          labelText.includes("en existencia") ||
          labelText.includes("in stock") ||
          labelText.includes("disponible")
        ) {
          inStockInputByForm.set(facetsForm, input);
        }
      }
    }

    if (inStockInputByForm.size === 0) {
      return false;
    }

    for (const input of inStockInputByForm.values()) {
      input.checked = true;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }

    setApplied();
    return true;
  }

  initDefaultAvailabilityFilter();
})();
